import * as React from 'react';

import { TBannerTheme } from '../../components/NewbuildingBanners/utils/bannerTypeToTheme';
import { PromosBanner } from '../../components/NewbuildingBanners/PromosBanner/PromosBanner';
import { CompilationBanner } from '../../components/NewbuildingBanners/CompilationBanner/CompilationBanner';
import { NewbuildingBrokerBanner } from '../../components/NewbuildingBanners/NewbuildingBrokerBanner/NewbuildingBrokerBanner';
import { MarketingBanner } from '../../components/NewbuildingBanners/MarketingBanner/MarketingBanner';
import { TBanners, TBannerTypes } from '../../types/newbuildingBanners/banners';
import { NewbuildingBrokerBannerButtonContainer } from './NewbuildingBrokerBannerButton';

interface IThemeMapperProps {
  type: TBannerTypes;
}

interface IUseBannerProp {
  themeMapper(props: IThemeMapperProps): TBannerTheme;
  data: TBanners;
  onClick(): void;
}

export const Banner = ({ themeMapper, data, onClick }: IUseBannerProp) => {
  switch (data.type) {
    case 'allPromos':
      return <PromosBanner onClick={onClick} theme={themeMapper({ type: data.type })} {...data} />;
    case 'marketing':
      return <MarketingBanner onClick={onClick} theme={themeMapper({ type: data.type })} {...data} />;
    case 'lastChanceDiscount':
      return <CompilationBanner onClick={onClick} theme={themeMapper({ type: data.type })} {...data} />;
    case 'topPromos':
      return <CompilationBanner onClick={onClick} theme={themeMapper({ type: data.type })} {...data} />;
    case 'newbuildingBroker': {
      return (
        <NewbuildingBrokerBanner
          theme={themeMapper({ type: data.type })}
          {...data}
          button={<NewbuildingBrokerBannerButtonContainer text={data.action.title} />}
        />
      );
    }
  }
};
